import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { canSeeGeneralNotes } from '../permissions/notes-access';

// Keeps anyone without general notes off the tagged-notes pages (desktop /tagged-notes and mobile
// /m/notes) — Corporate Viewers, and every user in a tenant that files notes under Client Profile
// Notes only. See `canSeeGeneralNotes`.
//
// The links to them are hidden, but notifications, planners, reference numbers and copied links all
// point there too, so the route is where it is enforced. Bounces to the dashboard, like
// corporateAdminGuard, rather than showing a 403.
//
// Reads the cached permission flags and tenant bootstrap synchronously. A cold cache (a deep link
// opened in a fresh tab before sign-in has filled it) reads as "allowed" — the same answer every
// other Viewer check in the app gives in that window.
export const notCorporateViewerGuard: CanActivateFn = (_route, state) => {
  if (canSeeGeneralNotes()) return true;
  return inject(Router).createUrlTree(['/']);
};
